/**
 * Receipt variation — paper-receipt aesthetic. Uses the same row interactions
 * as ListVariation; the differences are purely cosmetic (mono font, thin
 * dividers, totals block at the bottom).
 */
import { useMemo } from "react";
import { ListVariation } from "./ListVariation";
import type { VariationProps } from "./types";

export function ReceiptVariation(props: VariationProps) {
  const { lines, state, format } = props;
  const totals = useMemo(() => {
    let claimed = 0;
    let unclaimed = 0;
    for (const ln of lines) {
      const sharers = state.sharers[ln.lineId] ?? [];
      if (sharers.length === 0) unclaimed += ln.totalAmount;
      else claimed += ln.totalAmount;
    }
    return { claimed, unclaimed, total: claimed + unclaimed };
  }, [lines, state.sharers]);

  return (
    <div
      style={{
        background: "#fdfaf3",
        margin: "8px 16px 0",
        borderRadius: 12,
        padding: "8px 4px",
        boxShadow: "inset 0 0 0 1px #ecdcc1",
        fontFamily:
          "ui-monospace, SFMono-Regular, Menlo, monospace",
      }}
    >
      <div
        style={{
          textAlign: "center",
          fontSize: 11,
          color: "#7a5b2e",
          letterSpacing: 1,
          padding: "8px 0 12px",
          fontWeight: 700,
        }}
      >
        — TABLE RECEIPT —
      </div>
      <div style={{ padding: "0 12px" }}>
        <ListVariation {...props} />
      </div>
      <div
        style={{
          margin: "12px 16px 12px",
          paddingTop: 10,
          borderTop: "1px dashed #ecdcc1",
          display: "flex",
          flexDirection: "column",
          gap: 4,
          fontSize: 12,
          color: "#5b4416",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Claimed</span>
          <span>{format(totals.claimed)}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Unclaimed</span>
          <span>{format(totals.unclaimed)}</span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontWeight: 800,
            color: "#3b2c12",
            paddingTop: 6,
            borderTop: "1px dashed #ecdcc1",
            marginTop: 4,
          }}
        >
          <span>TOTAL</span>
          <span>{format(totals.total)}</span>
        </div>
      </div>
    </div>
  );
}
